<template>
  <GetCertified
    :text="$t('text-bg-hens')"
    :btn-text="$t(btnText)"
    :handleClick="handleClick"
  />
</template>

<script>
import GetCertified from './GetCertified.vue'
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'

export default {
  props: {
    btnText: {
      type: String,
      default: 'button-get-certified',
    }
  },
  components: {
    GetCertified,
  },
  setup() {
    const router = useRouter()
    const route = useRoute();
    const routeName = computed(() => route.name)

    const handleClick = () => {
      openForm()
    }

    const openForm = () => {
      if (routeName.value !== 'contact') {
        router.push({
          name: 'contact',
          hash: '#form-contact'
        })
      } else {
        const el = document.querySelector('#form-contact');
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }

    return {
      handleClick,
    }
  }
}
</script>
